import Header from './common/Header';
import Footer from './common/Footer';
import SupportForm from './common/elements/SupportForm';

const SimpleLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <SupportForm />
  </>
);
export { SimpleLayout };
